import { render, staticRenderFns } from "./changelog_suggest_modal.vue?vue&type=template&id=069abfc1&"
import script from "./changelog_suggest_modal.vue?vue&type=script&lang=js&"
export * from "./changelog_suggest_modal.vue?vue&type=script&lang=js&"
import style0 from "./changelog_suggest_modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports